import React from 'react';
import './navigation.scss';
import { hasPermission } from '../../../../../utils/controller';

const NavigationTabsCustomersDetails = ({ activeTab, setActiveTab, user }) => {
	const navTabs = hasPermission('sales.customers.statement', user?.role?.role_permissions)
		? ['Information', 'Transactions', 'Statement']
		: ['Information', 'Transactions'];

	return (
		<div>
			<ul className="nav mb-4 mt-2">
				{navTabs.map((item, index) => (
					<li
						key={index}
						className="nav-item"
					>
						<a
							className={`nav-link ${activeTab === item ? 'active' : ''} cursur-pointer`}
							href="#"
							onClick={() => setActiveTab(item)}
						>
							{item}
						</a>
					</li>
				))}
			</ul>
		</div>
	);
};

export default NavigationTabsCustomersDetails;
